export * from "@evercam/api/api"
import { axios } from "@evercam/api/api"

export default axios
